var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "platform-icon-wrapper" }, [
    _c(
      "div",
      { staticClass: "platform-icon" },
      [
        _vm.platform === "web" || _vm.platform === "web-visitor-ip"
          ? _c("webIcon", { attrs: { color: "black" } })
          : _vm._e(),
        _vm._v(" "),
        _vm.platform === "supsis"
          ? _c("SupsisIcon", { staticClass: "icon" })
          : _vm._e(),
        _vm._v(" "),
        _vm.platform === "whatsapp"
          ? _c("whatsapp-icon", { attrs: { color: "#25D366" } })
          : _vm._e(),
        _vm._v(" "),
        _vm.platform === "email" ? _c("gmail-icon") : _vm._e(),
        _vm._v(" "),
        _vm.platform === "instagram"
          ? _c("InstagramIcon", { attrs: { "special-background-mode": "" } })
          : _vm._e(),
        _vm._v(" "),
        _vm.platform === "messenger"
          ? _c("MessengerIcon", { staticClass: "icon" })
          : _vm._e(),
        _vm._v(" "),
        _vm.platform === "telegram"
          ? _c("TelegramIcon", { staticClass: "icon" })
          : _vm._e(),
        _vm._v(" "),
        _vm.platform === "linkedin"
          ? _c("LinkedinIcon", { staticClass: "icon" })
          : _vm._e(),
        _vm._v(" "),
        _vm.platform === "calendar"
          ? _c("calendar-icon", { staticClass: "icon" })
          : _vm._e(),
        _vm._v(" "),
        _vm.platform === "meta-leads"
          ? _c("MetaIcon", { staticClass: "icon" })
          : _vm._e(),
        _vm._v(" "),
        _vm.platform === "web-visitor"
          ? _c("img", {
              staticClass: "icon",
              attrs: {
                src: "https://static.supsis.live/common/email/supsisyazisislogo.png",
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }